import type { SorterResult } from 'antd/es/table/interface';
import { IFilterSettings }   from '../../Domain/Repositories/BaseRepository/BaseRepository';

export const convertToRequestSorting = (sorter:  SorterResult<any> | SorterResult<any>[]): IFilterSettings['sorting']|void => {
  if (!sorter) {
    return;
  }

  const getSorter = (sorter: SorterResult<any>): IFilterSettings['sorting'] => {
    const { field, order } = sorter;
    if(!field || !order) {
      return;
    }
    return { field: field as string, order: order === 'ascend' ? 'ASC' : 'DESC' };
  }

  if (Array.isArray(sorter)) {
    return getSorter(sorter[0]);
  }
  return getSorter(sorter);
}
